import { TermsAndConditionsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class TermsAndConditions extends DomainEntity<TermsAndConditionsModelDto> {
    public static from(dto: TermsAndConditionsModelDto): TermsAndConditions {
        return new TermsAndConditions(dto);
    }

    public static createNew(): TermsAndConditions {
        return new TermsAndConditions({ text: '', requireUsersAcceptanceAfterEdit: true });
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get text(): string {
        return this.dto.text ?? '';
    }

    public set text(value: string) {
        this.dto.text = value;
    }

    public get requireUsersAcceptanceAfterEdit(): boolean {
        return this.dto.requireUsersAcceptanceAfterEdit ?? false;
    }

    public set requireUsersAcceptanceAfterEdit(value: boolean) {
        this.dto.requireUsersAcceptanceAfterEdit = value;
    }

    public get isEmpty(): boolean {
        return !this.dto.text;
    }
}
